import axios from "axios";
import { API } from "configs/api";

export const discountApi = {
  getOwnerDiscount: (params) => axios.get(API.discounts, { token: true, params }),
  postDiscount: (body) => axios.post(API.discounts, body, { token: true, formData: true }),
  deleteDiscount: (id) => axios.delete(`${API.discounts}/${id}`, { token: true, id }),
  putDiscount: ({ id, ...body }) => axios.put(`${API.discounts}/${id}`, body, { token: true }),
};
